import { useEffect, useRef, useState } from "react";
import { AlertSeverityEnum, TreeNode } from "../interfaces";
//import { read, utils } from 'xlsx';
import { findObjectById, flattenChildren, getNextInSeries, newCuentaSchema, removeLeadingZero } from "../utils";
import { useUiStore } from "@/store/ui";
import { useFetchCrearPlanCuenta, useFetchEditarPlanCuenta, useFetchgetPlanCuentaByEmpresa } from "../actions/erp";
import { useAuthStore } from "@/store/auth";
import { IPlanCuentaFrom } from "@/erp";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";


export const usePlanCuenta = () => {


  const [treeData, setTreeData] = useState<TreeNode[]>([]);
  const [editNodeId, setEditNodeId] = useState<string | null>(null);
  const [editNodeName, setEditNodeName] = useState<string>('');
  const [expanded, setExpanded] = useState<string[]>([]);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [treeDataLista, setTreeDataLista] = useState<TreeNode[]>([]); //Arreglo de nodos antes de transformar en un árbol jerarquía

  const [modalOpen, setModalOpen] = useState(false);

  const [nodeId, setNodeId] = useState('');
  //Store
  const setAlert = useUiStore.getState().setAlert;
  const empresa = useAuthStore.getState().user?.empresa

  //Fetch
  const { isLoading: isLoadingPlanCuenta, data: dataPlanCuenta } = useFetchgetPlanCuentaByEmpresa(empresa!, true);
  const { mutateAsync: fetchEditarPlanCuenta, isPending: isPendingEditarPlanCuenta } = useFetchEditarPlanCuenta();
  const { mutateAsync: fetchCrearPlanCuenta } = useFetchCrearPlanCuenta();


  //FORMULARIO
  const form = useForm<IPlanCuentaFrom>({
    resolver: yupResolver(newCuentaSchema),
  });

  const {
    handleSubmit,
    reset,
  } = form;

  useEffect(() => {

    if (!isLoadingPlanCuenta) {

      setTreeDataLista(flattenChildren(dataPlanCuenta?.cuentas || []));
      setTreeData(dataPlanCuenta?.cuentas || [])
    }

  }, [isLoadingPlanCuenta])


  const onSubmit = (form: IPlanCuentaFrom) => {

    if (editNodeId) { //editar
      if (editNodeId != form.codigo) {
        const existe = treeDataLista.find(e => e.id == form.codigo);
        if (existe) return setAlert(true, 'Existe un plan de cuenta con el mismo codigo.', AlertSeverityEnum.warning);
      }
      editNode(editNodeId, form);
      setModalOpen(false);
      reset({})
      setEditNodeId('')
      return;
    }

    //crear
    const existe = treeDataLista.find(e => e.id == form.codigo);
    if (existe) return setAlert(true, 'Existe un plan de cuenta con el mismo codigo.', AlertSeverityEnum.warning);
    if (nodeId) {
      addNode(form)
    } else {
      addNodePadre(form);
    }
    setNodeId('');
    reset({})
    setModalOpen(false);
  }

  const addNodePadre = async (form: IPlanCuentaFrom) => {

    const newNodo: TreeNode = {
      id: form.codigo,
      name: form.nombre,
      children: []
    }

    const copyNode = [...treeData]
    copyNode.push(newNodo);
    setTreeData(copyNode);
    await handleCreateOrEditPlanCuenta(copyNode);

  }

  const addNode = async (form: IPlanCuentaFrom) => {

    const newTreeData = [...treeData];
    const addChild = (nodes: TreeNode[]) => {
      nodes.forEach((node) => {
        if (node.id === nodeId) {
          const newNode: TreeNode = {
            id: form.codigo,
            name: form.nombre,
          };

          node.children ? node.children.push(newNode) : (node.children = [newNode]);
        } else if (node.children) {
          addChild(node.children);
        }
      });
    };
    addChild(newTreeData);
    setTreeData(newTreeData);
    await handleCreateOrEditPlanCuenta(newTreeData);

  }

  const nodeSaveTemp = (id: string) => {
    let next = ''
    if (id) {
      const existe = findObjectById(treeData, id);
      if (existe?.children && existe?.children?.length > 0) {
        const previus = existe.children?.at(-1)?.id
        next = getNextInSeries(previus || '');
      } else {
        next = `${existe?.id}.1`
      }
    } else {
      const previus = treeData.at(-1)?.id
      if (previus) {
        next = (+previus + 1).toString();
      } else {
        next = '1'
      }
    }

    reset({ codigo: next, nombre: '' })
    setModalOpen(true)
    setNodeId(id);
  };

  const deleteNode = async (id: string) => {
    const deleteChild = (nodes: TreeNode[]): TreeNode[] => {
      return nodes.filter((node) => {
        if (node.id === id) {
          return false;
        }
        if (node.children) {
          node.children = deleteChild(node.children);
        }
        return true;
      });
    };
    const newTreeData = deleteChild(treeData);

    setTreeData(newTreeData);
    await handleCreateOrEditPlanCuenta(newTreeData);

  };

  const nodeEditTemp = (id: string, name: string) => {
    setEditNodeId(id);
    reset({
      codigo: id,
      nombre: name
    });
    setModalOpen(true);
  };

  const editNode = async (id: string, form: IPlanCuentaFrom) => {
    const editChild = (nodes: TreeNode[]) => {
      nodes.forEach((node) => {
        if (node.id === id) {
          node.name = form.nombre;
          node.id = form.codigo;
        } else if (node.children) {
          editChild(node.children);
        }
      });
    };

    const newData = [...treeData];

    editChild(treeData);
    setTreeData(newData)

    await handleCreateOrEditPlanCuenta(newData);

  }

  const handleToggle = (_event: React.ChangeEvent<{}>, nodeIds: string[]) => {
    setExpanded(nodeIds);
  };

  const expandAllNodes = (nodes: TreeNode[]): string[] => {
    let allNodeIds: string[] = [];
    const getAllNodeIds = (nodes: TreeNode[]) => {
      nodes.forEach((node) => {
        allNodeIds.push(node.id);
        if (node.children) {
          getAllNodeIds(node.children);
        }
      });
    };
    getAllNodeIds(nodes);
    return allNodeIds;
  };

  const handleExpandAll = () => {
    const allNodeIds = expandAllNodes(treeData);
    setExpanded(allNodeIds);
  };

  const handleCollapseAll = () => {
    setExpanded([]);
  };

  //CARGCAR EXCEL
  const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files && event.target.files[0];

    if (file) {
      try {
        const reader = new FileReader();
        reader.onload = async (e) => {
          const data = e.target?.result;
          if (data) {
            const wb = XLSX.read(data, { type: 'binary' });
            const ws = wb.Sheets[wb.SheetNames[0]]; // get the first worksheet
            const aux: TreeNode[] = XLSX.utils.sheet_to_json<TreeNode>(ws, { header: ['id', 'name'] }); // generate objectss
            aux.shift();
            const clean = aux.map(node => ({
              ...node,
              id: removeLeadingZero((node.id).toString()),
              id_original: node.id,
              nombre_compuesto: `${removeLeadingZero((node.id).toString())} - ${node.name}`
            }));

            detectDuplicateIds(clean);
            //if (codeDuplicate) return;
            const js = buildTree(clean);
            await handleCreateOrEditPlanCuenta(js);
            setTreeData(js);
          }


        };
        reader.readAsArrayBuffer(file);
      } catch (error) {

      } finally {
        // Resetear el valor del input de archivo para permitir recargar el mismo archivo

        if (fileInputRef.current) {
          fileInputRef.current.value = '';
        }
      }
    }
  };

  /**
   * Descargar plantilla de excel
   * 
  */
  const handleDownloadPlantilla = () => {
    const filePath = '/src/assets/documentos/PlanCuentasPlantilla.xls';
    const link = document.createElement('a');
    link.href = filePath;
    link.download = 'PlanCuentasPlantilla.xls';
    link.click();

  }

  const buildTree = (nodes: any[]): TreeNode[] => {
    const nodeMap: { [key: string]: TreeNode } = {};
    const tree: TreeNode[] = [];

    // Crear nodos iniciales sin estructura jerárquica
    nodes.forEach((node) => {
      const idNode = node.id;
      nodeMap[idNode] = { ...node, id: idNode, children: [] };
    });


    // Construir la estructura jerárquica
    nodes.forEach((node) => {
      const idNode = node.id
      const idParts = idNode.split(".");
      if (idParts.length === 1) {
        // Es un nodo de nivel superior
        tree.push(nodeMap[idNode]);
      } else {
        // Es un subnodo
        const parentId = idParts.slice(0, -1).join(".");
        nodeMap[parentId]?.children?.push(nodeMap[idNode]);
      }
    });

    return tree;
  };

  const detectDuplicateIds = (arr: TreeNode[]) => {
    const idsSet = new Set<string | number>();
    for (const obj of arr) {
      if (idsSet.has(obj.id)) {
        setAlert(true, `Se ha notado que hay código duplicado en el archivo ${obj.id_original}, Corregirlo para evitar posibles impactos en la empresa.`, AlertSeverityEnum.warning);
        //return true; // Se encontró un ID duplicado
      }
      idsSet.add(obj.id);
    }

    return false; // No se encontraron IDs duplicados
  };

  async function handleCreateOrEditPlanCuenta(js: TreeNode[]) {

    setTreeDataLista(flattenChildren(js || []));

    if (dataPlanCuenta?.cuentas) {
      await fetchEditarPlanCuenta({
        id: dataPlanCuenta?.id_plancuenta!,
        data: {
          cuentas: js
        }
      });
    } else {
      await fetchCrearPlanCuenta({
        empresa: empresa!,
        cuentas: js,
        estado: true,
        nombre: empresa!
      });
    }
  }
  return {
    fileInputRef,

    treeData,
    setTreeData,
    editNodeId,
    setEditNodeId,
    editNodeName,
    setEditNodeName,

    addNode: nodeSaveTemp,
    addNodePadre,
    editNode: nodeEditTemp,
    deleteNode,

    expanded,
    handleToggle,
    handleCollapseAll,
    handleExpandAll,

    handleFileUpload,
    handleDownloadPlantilla,
    

    isLoadingPlanCuenta,
    isPendingEditarPlanCuenta,

    setModalOpen,
    modalOpen,

    onSubmit,
    handleSubmit,
    form
  }
}